import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { Roles } from '../models/roles';
import { AccountTypes } from '../models/account_types';

@Injectable()
export class AuthGuard {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = this.authenticationService.userValue;
    if (user) {
      // Get allowed types, roles and plans from route data
      const allowedAccountTypes = route.data['account_types'] || [
        AccountTypes.Merchant,
        AccountTypes.Delivery,
      ];
      const allowedRoles = route.data['roles'] || [Roles.Admin];
      const allowedPlans = route.data['plans'] || [1, 2, 3];

      // Check if user's account type, role and plan are allowed
      const hasAccountType = allowedAccountTypes.includes(
        user.user.business.type,
      );
      const hasRole = allowedRoles.includes(user.user.role);
      const hasPlan = allowedPlans.includes(user.user.business.plan);

      if (hasAccountType && hasRole && hasPlan) {
        return true;
      } else {
        // Redirect to orders if no access
        this.router.navigate(['/dashboard/orders']);

        return false;
      }
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
